import { Trainings } from "./trainings.model";

export class JobsTrainings {
  private id: number;
  private trainings: Trainings;
  private levelOfStudy: string;
  private rating: number;
  private certificat_rating: number;

  constructor(JobsTrainings: any) {
    this.id = JobsTrainings.id;
    this.trainings = JobsTrainings.trainings;
    this.levelOfStudy = JobsTrainings.levelOfStudy;
    this.rating = JobsTrainings.rating;
    this.certificat_rating = JobsTrainings.certificat_rating;
  }

  getTraining(): Trainings {
    return this.trainings;
  }

  getLevelOfStudy(): string {
    return this.levelOfStudy;
  }

  getRating(): number {
    return this.rating;
  }
  getCertificatRating(): number {
    return this.certificat_rating;
  }

}